/**
 * Job type formatting utility
 * Maps job type values to display labels
 */

export const JOB_TYPES = [
  { value: 'full_time', label: 'Full Time' },
  { value: 'part_time', label: 'Part Time' },
  { value: 'permanent', label: 'Permanent' },
  { value: 'contract', label: 'Contract' },
  { value: 'fixed_term', label: 'Fixed Term' },
  { value: 'temporary', label: 'Temporary' },
  { value: 'temp_to_perm', label: 'Temp to Perm' },
];

/**
 * Get display label for a job type value
 * @param {string} jobType - The job type value (e.g., 'full_time')
 * @returns {string} The display label (e.g., 'Full Time')
 */
export const formatJobType = (jobType) => {
  if (!jobType) return '';
  
  const found = JOB_TYPES.find(t => t.value === jobType);
  if (found) return found.label;
  
  // Fallback: convert snake_case to Title Case
  return jobType
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Get badge color classes for a job type
 * Each job type has a unique color to distinguish them visually
 * @param {string} jobType - The job type value
 * @returns {string} Tailwind CSS classes for the badge
 */
export const getJobTypeBadgeColor = (jobType) => {
  const colors = {
    'full_time': 'bg-green-100 hover:bg-green-200 text-green-800',
    'part_time': 'bg-amber-100 hover:bg-amber-200 text-amber-800',
    'permanent': 'bg-emerald-100 hover:bg-emerald-200 text-emerald-800',
    'contract': 'bg-orange-100 hover:bg-orange-200 text-orange-800',
    'fixed_term': 'bg-teal-100 hover:bg-teal-200 text-teal-800',
    'temporary': 'bg-rose-100 hover:bg-rose-200 text-rose-800',
    'temp_to_perm': 'bg-indigo-100 hover:bg-indigo-200 text-indigo-800',
  };
  
  return colors[jobType] || 'bg-slate-100 hover:bg-slate-200 text-slate-700';
};

export default formatJobType;
